import React from 'react';
import { getColorForClass } from '../constants/colors';
import './ColorLegend.css';

const ColorLegend = ({ detections }) => {
  const uniqueClasses = [];

  if (detections && detections.length > 0) {
    const seen = new Set();

    detections.forEach((det) => {
      if (!seen.has(det.class_id)) {
        seen.add(det.class_id);
        uniqueClasses.push({ id: det.class_id, label: det.label });
      }
    });

    uniqueClasses.sort((a, b) => a.id - b.id);
  }

  if (!uniqueClasses.length) {
    return null;
  }

  return (
    <div className="color-legend">
      <div className="legend-header">
        <h3>Chú thích màu sắc</h3>
        <span className="legend-count">{uniqueClasses.length} loại đã phát hiện</span>
      </div>
      <div className="legend-items">
        {uniqueClasses.map((cls, index) => (
          <div key={cls.id} className="legend-item">
            <div 
              className="color-box"
              style={{ backgroundColor: getColorForClass(cls.id) }}
            ></div>
            <span className="class-label">{cls.label}</span>
            <span className="class-id">ID: {cls.id}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorLegend;
